import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { FilePdfOutlined } from '@ant-design/icons'
import { IconWrapper, Image } from './styled'

const Attachment = ({ fileUrl, contentType, onClick }) => {
  const isPdfFile = contentType === 'application/pdf'
  const isTiff = contentType === 'image/tiff'

  return (
    <IconWrapper onClick={onClick} data-test="attachment_id">
      {(isPdfFile && <FilePdfOutlined style={{ fontSize: '80px' }} />) ||
        (isTiff ? (
          <span>No preview for .tiff files</span>
        ) : (
          <Image src={fileUrl} />
        ))}
    </IconWrapper>
  )
}

Attachment.propTypes = {
  fileUrl: PropTypes.string.isRequired,
  contentType: PropTypes.string.isRequired,
  onClick: PropTypes.func
}

export default memo(Attachment)
